import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    SYear:"",
}

const SelecYearSlice = createSlice({
    name: "SelecYearSlice",
    initialState,

    reducers: {
        SelecYearData(state, action) {
            return {
                    SYear:action.payload.SYear,
            };
        }
    }
})
export const { SelecYearData } = SelecYearSlice.actions;
export default SelecYearSlice.reducer;